var finalFiles = {};

jQuery(document).ready(function ($) {

    // preview image ready for upload ---------------------------------------------------------------------------------
    if (window.File && window.FileList && window.FileReader) {
        $(document).on("change", ".js-upload--file", function (e) {

            const upload = $(this),
                files = e.target.files,
                filesLength = files.length,
                uploadLabel = upload.parents('.f-file-upload').find('.f-file-upload__label');

            if (filesLength === 1) {
                const f = files[0],
                    fileReader = new FileReader();

                fileReader.onload = (function (e) {
                    uploadLabel.text(f.name).addClass('is-active');
                });

                fileReader.readAsDataURL(f);
            } else {
                uploadLabel.text(string.files.replace('%s', filesLength)).addClass('is-active').attr('title', get_titles(files, 'name'));
            }
        });
    } else {
        alert("Your browser doesn't support to File API")
    }


    // clear file input and img preview -------------------------------------------------------------------------------
    $('.js-cancel').click(function () {
        const cancel = $(this).parents('.f-file-upload');
        $(cancel).find('.js-upload--file').val("");
        $(cancel).find('.f-file-upload__label').text('Upload file').removeClass('is-active').removeAttr('title');
    });

    // remove file input and img preview ------------------------------------------------------------------------------
    $(document).on("click", ".js-delete", function () {
        $(this).parent('div.js-category').remove();
    });

    // remove consideration input fields ------------------------------------------------------------------------------
    $(document).on("click", ".js-remove", function () {
        $(this).parent('div.consideration').remove();
    });

    function get_titles(array) {
        const collected = [],
            length = array.length;

        for (let i = 0; i < length; i++) {
            collected.push(array[i].name);
        }

        return collected.join(', ');
    }

});
